module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/vi/4-20d029917a6111fddb5ed15a586c0d16.jpg";